module.exports = __webpack_public_path__ + "static/media/logos_squares_CoOrg_Cyberport.6547047d.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_CoOrg_Cyberport.png
// module id = 37
// module chunks = 0